import { render, staticRenderFns } from "./ProcMultiSelect.vue?vue&type=template&id=0fcdf3ac"
import script from "./ProcMultiSelect.vue?vue&type=script&lang=js"
export * from "./ProcMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports